// extracted by mini-css-extract-plugin
export default {"button":"LoginButton_button__lrDdV","innerButton":"LoginButton_innerButton__9cGiy"};